import React, { useId } from "react";
import PropTypes from "prop-types";

const paths = [
  "M15.6866 23.7654H15.5393C10.4853 23.7654 8.04931 21.7734 7.62798 17.3114C7.61724 17.1992 7.62876 17.0861 7.66189 16.9784C7.69502 16.8708 7.7491 16.7707 7.82102 16.6839C7.89294 16.5972 7.9813 16.5255 8.08099 16.4731C8.18069 16.4205 8.28977 16.3883 8.40198 16.3781C8.85731 16.3321 9.28998 16.6848 9.3353 17.1515C9.6653 20.7261 11.3506 22.0581 15.5507 22.0581H15.6986C20.3319 22.0581 21.9707 20.4188 21.9707 15.7861V8.3641C21.9707 3.73143 20.3313 2.0921 15.6986 2.0921H15.5507C11.3273 2.0921 9.64265 3.44676 9.3353 7.08944C9.27864 7.5561 8.87998 7.90943 8.40198 7.86344C8.28982 7.85459 8.18051 7.82371 8.08031 7.77257C7.9801 7.72143 7.89097 7.65101 7.81802 7.56537C7.74508 7.47972 7.68973 7.38052 7.65517 7.27346C7.62062 7.16639 7.60753 7.05357 7.61664 6.94143C8.0033 2.41143 10.4513 0.384766 15.54 0.384766H15.6879C21.276 0.384766 23.6666 2.77544 23.6666 8.36477V15.7861C23.6666 21.3755 21.276 23.7654 15.6866 23.7654Z",
  "M15.4127 12.9286H2.45934C1.99201 12.9286 1.60468 12.542 1.60468 12.0753C1.60468 11.6086 1.99201 11.2219 2.45868 11.2219H15.412C15.8786 11.2219 16.266 11.6086 16.266 12.0753C16.266 12.542 15.8794 12.9286 15.4127 12.9286Z",
  "M4.99736 16.7419C4.78136 16.7419 4.5647 16.6619 4.39403 16.4919L0.580694 12.6786C0.421996 12.5178 0.333008 12.3011 0.333008 12.0753C0.333008 11.8494 0.421996 11.6326 0.580694 11.4719L4.39403 7.65857C4.55474 7.49987 4.7715 7.41089 4.99736 7.41089C5.22322 7.41089 5.43999 7.49987 5.60069 7.65857C5.75939 7.81928 5.84838 8.03604 5.84838 8.26191C5.84838 8.48777 5.75939 8.70453 5.60069 8.86524L2.39069 12.0753L5.60069 15.2853C5.75939 15.4459 5.84838 15.6627 5.84838 15.8886C5.84838 16.1145 5.75939 16.3312 5.60069 16.4919C5.44136 16.6626 5.21403 16.7419 4.99736 16.7419Z",
];

const gradients = [
  { x1: "22.5553", y1: "5.18612", x2: "5.58607", y2: "17.1879" },
  { x1: "15.251", y1: "11.5724", x2: "14.9578", y2: "14.1667" },
  { x1: "5.46655", y1: "9.32708", x2: "-0.914449", y2: "13.2124" },
];

const filters = [
  { x: "3.11383", y: "-4.11523", width: "25.0528", height: "32.3806" },
  { x: "-2.89532", y: "6.72192", width: "23.6613", height: "10.7068" },
  { x: "-4.16699", y: "2.91089", width: "14.5154", height: "18.3311" },
];

const DropShadowFilter = ({ id, bounds }) => (
  <filter
    id={id}
    {...bounds}
    filterUnits="userSpaceOnUse"
    colorInterpolationFilters="sRGB"
  >
    <feFlood floodOpacity="0" result="BackgroundImageFix" />
    <feColorMatrix
      in="SourceAlpha"
      type="matrix"
      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      result="hardAlpha"
    />
    <feOffset dx="-0.5" dy="0.5" />
    <feGaussianBlur stdDeviation="2" />
    <feComposite in2="hardAlpha" operator="out" />
    <feColorMatrix
      type="matrix"
      values="0 0 0 0 0.415686 0 0 0 0 0.890196 0 0 0 0 0.976471 0 0 0 0.25 0"
    />
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1" />
    <feColorMatrix
      in="SourceAlpha"
      type="matrix"
      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      result="hardAlpha"
    />
    <feOffset dx="0.5" dy="-0.5" />
    <feGaussianBlur stdDeviation="2" />
    <feComposite in2="hardAlpha" operator="out" />
    <feColorMatrix
      type="matrix"
      values="0 0 0 0 0.85098 0 0 0 0 0.27451 0 0 0 0 0.937255 0 0 0 0.3 0"
    />
    <feBlend mode="normal" in2="effect1" result="effect2" />
    <feBlend mode="normal" in="SourceGraphic" in2="effect2" result="shape" />
  </filter>
);

DropShadowFilter.propTypes = {
  id: PropTypes.string.isRequired,
  bounds: PropTypes.object.isRequired,
};

const LogoutIcon = ({
  selected,
  width,
  height,
  className,
  ...props
}) => {
  const id = useId().replace(/:/g, "");
  const isActive = selected;
  const clipId = `logout-clip-${id}`;
  const innerClipId = `logout-inner-clip-${id}`;
  const filterIds = paths.map((_, index) => `logout-filter-${index}-${id}`);
  const gradientIds = paths.map((_, index) => `logout-gradient-${index}-${id}`);

  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath={`url(#${clipId})`}>
        <g
          opacity={isActive ? undefined : "0.7"}
          clipPath={`url(#${innerClipId})`}
        >
          {paths.map((path, index) => (
            <g key={path} filter={`url(#${filterIds[index]})`}>
              <path d={path} fill={`url(#${gradientIds[index]})`} />
            </g>
          ))}
        </g>
      </g>
      <defs>
        {filterIds.map((filterId, index) => (
          <DropShadowFilter
            key={filterId}
            id={filterId}
            bounds={filters[index]}
          />
        ))}
        {gradientIds.map((gradientId, index) => (
          <linearGradient
            key={gradientId}
            id={gradientId}
            {...gradients[index]}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D946EF" />
            <stop offset="1" stopColor="#67E8F9" />
          </linearGradient>
        ))}
        <clipPath id={clipId}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
        <clipPath id={innerClipId}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

LogoutIcon.propTypes = {
  selected: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

LogoutIcon.defaultProps = {
  selected: false,
  width: undefined,
  height: undefined,
  className: "",
};

export default LogoutIcon;
